import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-go-green',
  templateUrl: './go-green.component.html',
  styleUrls: ['./go-green.component.scss']
})
export class GoGreenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
